import "./HomeFooterWave.css";

export default function HomeFooterWave() {
  return (
    <section className="home-footer-wave" aria-hidden="true">
      <svg
        className="home-footer-wave__svg"
        viewBox="0 0 1440 150"
        preserveAspectRatio="none"
      >
        <path
          className="home-footer-wave__light"
          d="M0 0H1440V34C1195 70 960 88 720 88C480 88 245 70 0 34V0Z"
        />

        <path
          className="home-footer-wave__soft"
          d="M0 34C245 70 480 88 720 88C960 88 1195 70 1440 34V58C1205 92 965 110 720 110C475 110 235 92 0 58V34Z"
        />
      </svg>
    </section>
  );
}